module.exports = __webpack_public_path__ + "img/inquiry-bg.7c5be5a8.png";